import { Injectable } from '@angular/core';
import { QUESTIONS , iQuestion } from './questions';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class QuestionsService {
    public data =  new Subject();
    public currentQuestion: any = {};

    list(): iQuestion[] {
        this.data.next(QUESTIONS);
        this.currentQuestion = QUESTIONS[0];
        return QUESTIONS;
    }

    get(id: number) {
        this.currentQuestion = QUESTIONS.find(x => x.id === id );
        this.data.next(this.currentQuestion);
    }

    next() {
        this.currentQuestion = QUESTIONS.find(x => x.order === this.currentQuestion.order + 1 );
        this.data.next(this.currentQuestion);
    }

    prev() {
        this.currentQuestion = QUESTIONS.find(x => x.order === this.currentQuestion.order - 1 );
        this.data.next(this.currentQuestion);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/questions/questions.service.ts